export enum EmailStatus {
  Sent = 'Sent',
  Failed = 'Failed',
}

export interface RemittanceData {
  filename?: string;
  emailId?: string;
  emailSendDate?: string;
  emailStatus: EmailStatus;
}
